import "./KbSelection.css";
import NextBtn from "../../../Shared/Components/NextBtn/NextBtn";
import { useNavigate } from "react-router-dom";
import { KbSelectionConstant } from "../../../NewConstants/KbSelectionConstants";
import { useState, useEffect } from "react";
import { getAgents, getTooltip, getUserToken, getUserType, saveConsentFlag, saveOnboardingFlag, setUserApproach, setUserCadre, setUserKb,
  handleTooltipOnboarding,
  CheckLanguageSupport,
} from "../../../Actions/Utils";
import { saveKBSelection } from "../../../Actions/ChatActions";
import { isIframeDeployment } from "../../../Actions/Utils";

function KbSelection({ selectedLanguage, setStepIndex, setStartTour }) {
  const navigate = useNavigate();
  const [selectedCadre, setSelectedCadre] = useState("");
  const [selectedKb, setSelectedKb] = useState("");
  const [agents, setAgents] = useState([]);
  const [agentsCadre, setAgentsCadre] = useState([]);
  const [agentsKb, setAgentsKb] = useState([]);
  const [selectedApproach, setSelectedApproach] = useState("");
  const [agentsApproach, setAgentsApproach] = useState([]);

  useEffect(() => {
    const agentsData = getAgents();
    if (!agentsData || agentsData.length === 0) {
      navigate("/login");
      localStorage.clear();
      sessionStorage.clear();
      return;
    }else if (getUserType() !== "Internal"){
      if (!agentsData[0]?.onboarding){
        navigate("/guide");
      }else if (!agentsData[0]?.consent && !isIframeDeployment()){
        navigate("/consent");
      }else{
        navigate("/chat");
      }
    }
    setAgents(agentsData);
    const uniqueCadre = [...new Set(agentsData.map((agent) => agent.cadre))];
    setAgentsCadre(uniqueCadre);
    
  }, [navigate]);

  useEffect(() => {
    if (selectedCadre) {
      const filteredKb = [
        ...new Set(
          agents
            .filter((agent) => agent.cadre === selectedCadre)
            .map((agent) => agent.kb)
        ),
      ];
      setAgentsKb(filteredKb);
      setSelectedKb("");
    }
  }, [selectedCadre, agents]);

  useEffect(() => {
    if (selectedCadre && selectedKb) {
      const filteredApproach = [
        ...new Set(
          agents
            .filter((agent) => agent.cadre === selectedCadre && agent.kb === selectedKb)
            .map((agent) => agent.approach)
        ),
      ];
      setAgentsApproach(filteredApproach);
      setSelectedApproach("");
    }
  }, [selectedCadre, selectedKb, agents]);  

  const handleCadreChange = (e) => setSelectedCadre(e.target.value);
  const handleKbChange = (e) => setSelectedKb(e.target.value);
  const handleApproachChange = (e) => setSelectedApproach(e.target.value);

  const backArrowClick = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  const navigateBasedOnSupport = async () => {
    const route = await CheckLanguageSupport();
    if (route === "chat"){
      const tooltip = getTooltip();
      handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
      navigate("/chat");
    }else if (route === "language-check"){
      navigate("/language-check");
    }else{
      navigate("/login");
    }
  };

  const goToNext = async () => {
    const selectedAgent = agents.find(
      (agent) =>
        agent.cadre === selectedCadre &&
        agent.kb === selectedKb &&
        agent.approach === selectedApproach
    );    
  
    if (selectedAgent) {
      const res = await saveKBSelection(getUserToken(), selectedAgent.cadre, selectedAgent.kb, selectedAgent.approach, selectedLanguage);
      if (res?.status === 200) {
        setUserCadre(selectedAgent.cadre);
        setUserKb(selectedAgent.kb);
        setUserApproach(selectedAgent.approach);
        saveOnboardingFlag(selectedAgent.onboarding);
        saveConsentFlag(selectedAgent.consent);
        
        localStorage.removeItem("agents");
        
        if (!selectedAgent.onboarding) {
          navigate("/guide");
        } else if (!selectedAgent.consent && !isIframeDeployment()) {
          navigate("/consent");
        } else {
          await navigateBasedOnSupport();
        }
      }
      else {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
      }
    }
  };

  const canProceed = selectedCadre && selectedKb && selectedApproach;

  return (
    <>
      <div className="KbSelection">
        <div className="h-1/3 w-screen flex flex-col items-center justify-center text-center bg-cover bg-center relative px-5">
          <div className="absolute top-0 left-0">
            <NextBtn
              icon={"/Assets/Images/arrowLeftBlack.svg"}
              nextClick={backArrowClick}
            />
          </div>
          <div className="w-screen p-2 flex flex-col items-center justify-between mt-8">
            <div className="text-[20px] mb-4">
              {KbSelectionConstant.select[selectedLanguage]}
              <strong>{KbSelectionConstant.cadre[selectedLanguage]}</strong>
              {KbSelectionConstant.and[selectedLanguage]}
              <strong>{KbSelectionConstant.kb[selectedLanguage]}</strong>
            </div>
            <div className="text-[16px] mb-4">
              <strong>
                {KbSelectionConstant.subheading_info[selectedLanguage]}
              </strong>
            </div>
            <div className="text-gray-600 mb-4">
              {KbSelectionConstant.subheading_update[selectedLanguage]}
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col items-center justify-center relative">
          {/* Cadre Dropdown */}
          <div className="mb-4 pb-2 w-[95%] relative dropdown-container">
            <label className="text-[20px] font-semibold flex gap-2">
              <span className="bg-white rounded-md border border-solid border-[var(--dark-neutral-1)]">
                <img
                  className="h-5 w-5 m-1"
                  src="/Assets/Images/user.svg"
                  alt="User Icon"
                />
              </span>
              {KbSelectionConstant.cadre[selectedLanguage]}
            </label>
            <select
              name="Cadre"
              onChange={handleCadreChange}
              value={selectedCadre}
              required
              className="ml-9 mt-1 block w-[80%] p-3 border border-gray-300 rounded-md text-gray-700 focus:border-gray-500 bg-white appearance-none"
              style={{
                height: "3.5rem",
                backgroundColor: "white",
                backgroundImage: "url('/Assets/Images/down-arrow.svg')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 1rem center",
                backgroundSize: "1rem",
              }}
            >
              <option
                value=""
                style={{ height: "3rem", backgroundColor: "white" }}
                disabled
              >
                {KbSelectionConstant.input_cadre[selectedLanguage]}
              </option>
              {agentsCadre.map((option) => (
                <option
                  key={option}
                  value={option}
                  style={{ height: "3rem", backgroundColor: "white" }}
                  className="text-[var(--dark-neutral-2)]"
                >
                  {option}
                </option>
              ))}
            </select>
          </div>

          {/* KB Dropdown */}
          <div className="mb-4 pb-2 w-[95%] relative dropdown-container">
            <label className="text-[20px] font-semibold flex gap-2">
              <span className="bg-white rounded-md border border-solid border-[var(--dark-neutral-1)]">
                <img
                  className="h-5 w-5 m-1"
                  src="/Assets/Images/Open_Book_icon.svg.png"
                  alt="Book Icon"
                />
              </span>
              {KbSelectionConstant.kb[selectedLanguage]}
            </label>
            <select
              name="Kb"
              onChange={handleKbChange}
              value={selectedKb}
              required
              className="ml-9 mt-1 block w-[80%] p-3 border border-gray-300 rounded-md text-gray-700 focus:border-gray-500 bg-white appearance-none"
              style={{
                height: "3.5rem",
                backgroundColor: "white",
                backgroundImage: "url('/Assets/Images/down-arrow.svg')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 1rem center",
                backgroundSize: "1rem",
              }}
            >
              <option
                value=""
                style={{ height: "3rem", backgroundColor: "white" }}
                disabled
              >
                {KbSelectionConstant.input_kb[selectedLanguage]}
              </option>
              {agentsKb.map((option) => (
                <option
                  key={option}
                  value={option}
                  style={{ height: "3rem", backgroundColor: "white" }}
                  className="text-[var(--dark-neutral-2)]"
                >
                  {option}
                </option>
              ))}
            </select>
          </div>
          {/* Approach Dropdown */}
          <div className="mb-4 pb-2 w-[95%] relative dropdown-container">
            <label className="text-[20px] font-semibold flex gap-2">
              <span className="bg-white rounded-md border border-solid border-[var(--dark-neutral-1)]">
                <img
                  className="h-5 w-5 m-1"
                  src="/Assets/Images/approach.svg"
                  alt="Approach Icon"
                />
              </span>
              {KbSelectionConstant.approach[selectedLanguage]}
            </label>
            <select
              name="Approach"
              onChange={handleApproachChange}
              value={selectedApproach}
              required
              className="ml-9 mt-1 block w-[80%] p-3 border border-gray-300 rounded-md text-gray-700 focus:border-gray-500 bg-white appearance-none"
              style={{
                height: "3.5rem",
                backgroundColor: "white",
                backgroundImage: "url('/Assets/Images/down-arrow.svg')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 1rem center",
                backgroundSize: "1rem",
              }}
            >
              <option
                value=""
                style={{ height: "3rem", backgroundColor: "white" }}
                disabled
              >
                {KbSelectionConstant.input_approach[selectedLanguage]}
              </option>
              {agentsApproach.map((option) => (
                <option
                  key={option}
                  value={option}
                  style={{ height: "3rem", backgroundColor: "white" }}
                  className="text-[var(--dark-neutral-2)]"
                >
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="proceedBtn">
          {canProceed && (
            <NextBtn
              value={KbSelectionConstant.proceedButton[selectedLanguage]}
              icon={"/Assets/Images/nextWhiteIcon.svg"}
              bgColor={"var(--primary-dark)"}
              color={"var(--neutral-white)"}
              padx={48}
              nextClick={goToNext}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default KbSelection;
